<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="title">
          <el-select v-model="listQuery.status" placeholder="请选择状态" style="width: 200px;" clearable @change="SearchData">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->

      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column type="selection"></el-table-column>
      <el-table-column align="center" prop="avatar" label="头像 ">
        <template slot-scope="scope">
          <img :src="scope.row.avatar" style="width: 50px;height: 50px;border-radius: 50px;">
        </template>
      </el-table-column>
      <el-table-column align="center" prop="username" label="牧民账号 "> </el-table-column>
      <el-table-column align="center" prop="nickname" label="牧民昵称 "> </el-table-column>
      <el-table-column align="center" prop="realname" label="真实姓名 "></el-table-column>
      <el-table-column align="center" prop="phone" label="联系电话 "> </el-table-column>
      <el-table-column align="center" prop="status" label="状态 ">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            @change="changeState(scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="create_time" label="注册时间 "> </el-table-column>
      <el-table-column align="center" prop="creator_name" label="创建者 "> </el-table-column>
      <el-table-column align="center" prop="" label="操作" width="300" class-name="action">
        <template slot-scope="scopes">
          <el-button v-auth="'Herdsman.update'" size="mini" type="primary" icon="el-icon-edit" @click="HandleDetails(scopes.row)">编辑</el-button>
          <el-button v-auth="'Herdsman.update'" size="mini" type="success" @click="HandleDetails(scopes.row)">活畜信息</el-button>
          <el-button v-auth="'Herdsman.resetPwd'" type="info" size="mini" @click="RowDelete(scopes.row)">重置密码</el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-drawer
      ref="drawer"
      title="详情"
      :visible.sync="dialogFormVisible"
      direction="rtl"
      size="1000px"
      custom-class="demo-drawer"
    >
      <HerdsmanEdit v-if="dialogFormVisible" :id="edit_id" @close="dialogFormVisible = false"></HerdsmanEdit>
    </el-drawer>
  </div>
</template>

<script>
import api from '@/api/customer/herdsman' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
// import dict_data from '@/api/system/dict_data'
import HerdsmanEdit from './herdsmanEdit'

export default {
  name: 'Herdsman',
  components: { Pagination, HerdsmanEdit },
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      // rules: {
      // },
      edit_id: 0,
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id'
      }
      // activeName: 'first',
      // // 字典参数
      // dictionary: []
      // // 字典参数
    }
  },
  created() {
    this.loadData()
    // dict_data.Drop({
    //   sort: 'sort', order: 'asc', isPaginator: false,
    //   dict_code: ['loan_type', 'applicant_credit_investigation', 'marital_status', 'children_situation', 'breeding_method', 'breeding_mode', 'live_animals_loan_purposes', 'network_status', 'seasonal_culture_method', 'aquaculture_expenditure_type']
    // }).then(response => {
    //   this.dictionary = response.data
    // })
  },
  methods: {
    HandleDetails(row) {
      this.edit_id = row.id
      this.dialogFormVisible = true
    },
    changeState(row) {
      this.api.ChangeStatus({
        field: 'status',
        id: row.id,
        value: row.status
      }).then(response => {
        this.$notify({ title: '成功', message: '操作成功', type: 'success', duration: 2000 })
      }).catch(() => {
        this.$notify({ title: '失败', message: '操作失败', type: 'error', duration: 2000 })
        row.status = 1 - row.status
      })
    }

  }
}
</script>
